import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import styles from './ModalLoadPreparation.module.scss'

const ModalLoadPreparation: React.FC = () => {
  return (
    <div className={styles.overlay}>
      <div className={styles.modalContainer}>
        <FontAwesomeIcon className={styles.loadingIcon} icon={faSpinner} spinPulse={true} />
        <div className={styles.sectionText}>
          <p>ただいま申請準備を行なっています。</p>
          <p>そのままの状態でお待ちください。</p>
        </div>
      </div>
    </div>
  )
}
export default ModalLoadPreparation
